import * as React from 'react';
import { compose, withHandlers } from 'recompose';
import { ReportType } from 'types';
import { ColumnGroupControl } from './ColumnGroupControl';
import { TableColumn } from 'logic/reports/ReportSettings';
import { groupColumn, ungroupColumn } from 'logic/reports/tableColumns';

import './ColumnGroupControlList.css';

type OwnProps = {
    reportType: ReportType;
    columns: ReadonlyArray<TableColumn>;
    onChange: (columns: ReadonlyArray<TableColumn>) => void;
};

// Don't allow more than 4 levels of groups
const MAX_GROUPS = 4;

const RawColumnGroupControlList = ({ reportType, columns, handleGroupChanged, onChange }: RecomposeProps & OwnProps) => {
    const groupColumns =
        columns
            .filter(c => typeof c.groupIndex === 'number')
            .sort((a, b) => a.groupIndex! - b.groupIndex!);

    const remainingColumns =
        columns
            .filter(c => typeof c.groupIndex !== 'number')
            .filter(c => typeof c.visibleIndex === 'number') // Hide invisible columns
            .sort((a, b) => a.visibleIndex! - b.visibleIndex!);

    return (
        <div
            className="column-group-control-list"
        >
            { groupColumns.map((c, i) =>
                <ColumnGroupControl
                    key={ `${i}-${c.name}` }
                    reportType={ reportType }
                    groupIndex={ i }
                    selectedColumn={ c.name }
                    columns={ columns }
                    onGroupChanged={ handleGroupChanged }
                />
            ) }
            { !!remainingColumns.length && groupColumns.length < Math.min(MAX_GROUPS, columns.length - 2) &&
                <ColumnGroupControl
                    reportType={ reportType }
                    groupIndex={ groupColumns.length }
                    selectedColumn={ null }
                    columns={ remainingColumns }
                    onGroupChanged={ handleGroupChanged }
                />
            }
        </div>
    );
};

type RecomposeProps = {
    handleGroupChanged: (index: number, columnName: string | null) => void;
};

export const ColumnGroupControlList = compose<RecomposeProps & OwnProps, OwnProps>(
    withHandlers<OwnProps, RecomposeProps>({
        handleGroupChanged: ({ columns, onChange }) => (index: number, columnName: string | null) => {
            columns =
                columnName === null
                    ? ungroupColumn(columns, index)
                    : groupColumn(columns, columnName, index);

            onChange(columns);
        },
    }),
)(RawColumnGroupControlList);



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/tableLayout/ColumnGroupControlList.tsx